export const RED_BACKGROUND = "#fdf1f1";
export const RED = "#dc3545";
export const GREEN_BACKGROUND = "#e8f7eb";
export const GREEN = "#28a745";
export const GRAY_BACKGROUND = "#ededed";
export const GRAY = "#282828";
export const YELLOW_BACKGROUND = "#fffdef";
export const YELLOW = "#ffc107";
